import ReactDOM from "react-dom";

// import "./i18n";
import "./i18n/i18n"; // Ensure i18n is initialized
// import '@iconscout/react-unicons/css/line.css'; // Add this line to import Unicons CSS
// import "./assets/css/materialdesignicons.min.css";

import "./index.css";
import "./tailwind.css";
import "./globals.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { Provider } from "react-redux";
import PersistProvider from "./redux/store/persist-provider";
import { store } from "./redux/store/index";

import { NotificationProvider } from "../src/helpers/NotificationContext";
import { ErrorBoundary } from "./components/ErrorBoundary/ErrorBoundary";
import { Suspense } from "react";

if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/service-worker.js")
      .then((registration) => {
        console.log("✅ Service Worker registered:", registration);
      })
      .catch((err) => {
        console.error("❌ Service Worker registration failed:", err);
      });
  });
}


// const root = createRoot(container);
ReactDOM.render(
  <Provider store={store}>
    <PersistProvider>
      <NotificationProvider>
        <ErrorBoundary>
          {/* ✅ Wrap App with Suspense fallback */}
          <Suspense fallback={<div />}>
            <App />
          </Suspense>
        </ErrorBoundary>
      </NotificationProvider>
    </PersistProvider>
  </Provider>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
